import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import type { SystemPermission } from '../../context';

const useUserPermission = () => {
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );
  const userHasPermissions = (
    permissions: SystemPermission | SystemPermission[],
    mode: 'or' | 'and' = 'or',
  ): boolean => {
    if (!selectedTenancy) {
      return false;
    }
    if (!selectedTenancy.permissionsSetup) {
      return true;
    }
    if (!selectedTenancy.userPermissions) {
      return false;
    }

    if (Array.isArray(permissions)) {
      if (mode === 'and') {
        return permissions.every(
          (perm) => !!selectedTenancy.userPermissions![perm],
        );
      } else {
        return permissions.some(
          (perm) => !!selectedTenancy.userPermissions![perm],
        );
      }
    }
    return !!selectedTenancy.userPermissions[permissions];
  };
  return { userHasPermissions };
};

export default useUserPermission;
